import { Form, message } from "antd";
import {
  PlusCircleOutlined,
  GlobalOutlined,
  InfoCircleOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import ModalInterface from "../../Modal/Modal";
import { createEvent } from "../Application/Events.business";
import { AddIcon, CustomFormItem, CustomDatePicker } from "../../Utils/UI/Text";
import CustomError from "../../Utils/Domain/CustomError";
import moment from "moment";

const NewEvents = ({ onEventCreated }) => {
  const [form] = Form.useForm();

  async function handleSubmit() {
    try {
      const formValues = await form.validateFields();

      const eventData = {
        start_date: formValues.start_date
          ? moment(formValues.start_date).format("YYYY-MM-DD")
          : null,
        final_date: formValues.final_date
          ? moment(formValues.final_date).format("YYYY-MM-DD")
          : null,
        name: formValues.name?.trim(),
        country: formValues.country?.trim(),
      };

      if (eventData.start_date && eventData.final_date) {
        const start = moment(eventData.start_date);
        const end = moment(eventData.final_date);

        if (end.isBefore(start)) {
          message.error("La fecha final debe ser posterior a la fecha inicial");
          return false;
        }
      }

      await createEvent(eventData);

      form.resetFields();

      message.success("Evento creado exitosamente");

      if (onEventCreated) {
        onEventCreated();
      }

      return true;
    } catch (error) {
      console.error(" Error creating event:", error);

      const customError = new CustomError(error);
      message.error(customError.message);

      return false;
    }
  }

  return (
    <ModalInterface
      icon={<AddIcon titleAdd="Agregar nuevo Evento" />}
      title="Nuevo Evento"
      text="Agregar"
      form={form}
      handleSubmit={handleSubmit}
      PlusCircleOutlined={<PlusCircleOutlined />}
      cancelButtonProps={{ style: { display: "none" } }}
      okButtonProps={{ style: { display: "none" } }}
    >
      <Form layout="vertical" form={form} style={{ width: "100%" }}>
        <CustomFormItem
          label="Nombre del evento"
          name="name"
          placeholder="Ingrese un evento"
          maxLength={200}
          required={true}
          showCounter={true}
          tooltipText="Nombre del evento (máximo 200 caracteres)"
          iconSuffix={<InfoCircleOutlined style={{ color: "#1890ff" }} />}
          customRules={[
            {
              pattern: /^[A-Za-zÁÉÍÓÚáéíóúÑñ0-9\s]+$/,
              message: "Solo letras, números y espacios permitidos",
            },
            {
              validator: (_, value) => {
                if (value && value.trim().length === 0) {
                  return Promise.reject(
                    new Error("El nombre no puede estar vacío")
                  );
                }
                return Promise.resolve();
              },
            },
          ]}
        />

        <CustomFormItem
          label="País"
          name="country"
          placeholder="Ej: México"
          maxLength={100}
          required={true}
          showCounter={true}
          tooltipText="País donde se realizará el evento"
          iconSuffix={<GlobalOutlined style={{ color: "#fa541c" }} />}
          customRules={[
            {
              pattern: /^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+$/,
              message: "Solo letras y espacios permitidos",
            },
          ]}
        />

        <CustomDatePicker
          label="Fecha inicial"
          name="start_date"
          placeholder="Selecciona fecha de inicio"
          required={true}
          format="YYYY-MM-DD"
          iconSuffix={<CalendarOutlined style={{ color: "#52c41a" }} />}
          tooltipText="Fecha de inicio del evento"
        />

        <CustomDatePicker
          label="Fecha final"
          name="final_date"
          placeholder="Selecciona fecha final"
          required={true}
          format="YYYY-MM-DD"
          iconSuffix={<CalendarOutlined style={{ color: "#ff4d4f" }} />}
          tooltipText="Fecha de finalización del evento"
          customRules={[
            ({ getFieldValue }) => ({
              validator(_, value) {
                const startDate = getFieldValue("start_date");
                if (!value || !startDate) {
                  return Promise.resolve();
                }

                if (moment(value).isBefore(moment(startDate))) {
                  return Promise.reject(
                    new Error("La fecha final debe ser posterior a la inicial")
                  );
                }

                return Promise.resolve();
              },
            }),
          ]}
        />
      </Form>
    </ModalInterface>
  );
};

export default NewEvents;
